export default "__VITE_ASSET__alzliu1J__"